module.exports = __webpack_public_path__ + "static/img/High Transparency Silicone Rubber.0b1eb19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/High Transparency Silicone Rubber.jpg
// module id = +98l
// module chunks = 1